<div mat-dialog-title class="settings-title">
  <div>User Settings</div>
</div>
<div mat-dialog-content class="settings-body">
  <div class="container">
    <div class="settings-user-info">
      <fa-icon size="2x" [icon]="faUser"></fa-icon>
      <div *ngIf="!isLoading">
        <div>{{user.name}}</div>
        <div>{{user.email}}</div>
      </div>
      <div *ngIf="isLoading" class="spin">
        <fa-icon [icon]="faCircleNotch"></fa-icon>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="settings-actions">
      <div class="d-flex align-items-center justify-content-between">
        <span class="d-flex justify-content-between w-100" *ngIf="!isLoading">
          <strong>Computing Units:</strong>
          <span class="settings-computing-units"> {{computingUnits}}</span>
        </span>
        <span class="d-flex justify-content-between w-100" *ngIf="isLoading">
          <strong>Computing Units:</strong>
          <span class="settings-computing-units spin">
            <fa-icon [icon]="faCircleNotch"></fa-icon>
          </span>
        </span>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <button mat-raised-button (click)="getComputingUnits()" color="primary">
          <fa-icon [icon]="faRecycle"></fa-icon>
          Refresh
        </button>
        <button mat-raised-button (click)="buyComputingUnits()" color="primary">
          <fa-icon [icon]="faPlus"></fa-icon>
          Buy More
        </button>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <strong>Enable Email Notifications:</strong>
        <mat-slide-toggle *ngIf="!isLoading" class="settings-toggle" [checked]="userData?.enableEmailNotifications"
                          (change)="setUserEmailNotifications()">
        </mat-slide-toggle>
        <span *ngIf="isLoading" class="settings-computing-units spin">
          <fa-icon [icon]="faCircleNotch"></fa-icon>
        </span>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
</div>
<div mat-dialog-actions class="settings-footer">
  <button mat-raised-button (click)="close()" color="accent">Close</button>
</div>
